<app-admin-list-page [title]="'Projects' | translate">

  <a slot="actions" class="btn btn-primary" routerLink="/admin/externalpage/Project">
    {{'Add new' | translate}}
  </a>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
